(function () {
  const section = document.currentScript?.parentElement;
  if (window.pawkivoProductSliders) {
    window.pawkivoProductSliders.init(section);
    return;
  }

  function swiperInit(section) {
    if (!section) return;
    subSliderInit(section);
    sliderInit(section);
    popupSliderInit(section);
  }

  document.addEventListener("shopify:section:load", function (e) {
    swiperInit(e.target);
  });

  document.addEventListener("shopify:section:unload", function (e) {
    const section = e.target;
    const { modal } = getProductMediaPair(section);
    const sliders = new Set(section.querySelectorAll(".js-media-list, .js-media-sublist, .js-popup-slider"));
    modal?.querySelectorAll(".js-popup-slider").forEach((element) => sliders.add(element));
    sliders.forEach((element) => {
      if (element.swiper && !element.swiper.destroyed) element.swiper.destroy(true, true);
    });
    if (modal && !section.contains(modal)) {
      if (modal.hasAttribute("open")) modal.hide?.();
      modal.remove();
    }
  });

  window.pawkivoProductSliders = { init: swiperInit };
  swiperInit(section);
})();
